import SkuFlowChartSvg from 'src/assets/sku-flow-chart.svg?react';

export function SkuFlowChart({ className }: { className?: string }) {
  return (
    <SkuFlowChartSvg
      className={className}
      role="img"
      aria-label="SKU decision flow chart"
    />
  );
}
